export default [
    {
        dataName: "openJoints",
        label: "Packages",
        icon: "ThumbsUpIcon",
        type: "radialChart",
        value: ""
    },
    {
        dataName: "boxupJoints",
        label: "Packages",
        icon: "ThumbsUpIcon",
        type: "radialChart",
        value: ""
    },
    {
        dataName: "completedJoints",
        label: "Packages",
        icon: "ThumbsUpIcon",
        type: "radialChart",
        value: ""
    },
    
     
     
]